import {
  Form,
  Input,
  Checkbox,
  Link,
  Button,
  Space,
  Modal,
} from '@arco-design/web-react';
import { FormInstance } from '@arco-design/web-react/es/Form';
import { IconCodeSquare, IconMobile } from '@arco-design/web-react/icon';
import React, { useEffect, useRef, useState } from 'react';
import styles from './style/index.module.less';
import request from '@/request/request';
import { PageTypeRegister, PageTypeResetPassword } from './constants';
import CaptchaRegisterForm from './captchaRegisterForm';
export default function CaptchaLoginForm(props: {
  onTypeChange?: (arg: number) => void;
  onRegist?: (authToken: string, mobile: string) => void;
  userAgreemtnProtocol?: string;
  privacyPolicyProtocol?: string;
}) {
  const CaptchaTimeout = 60;

  const formRef = useRef<FormInstance>();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // 禁止发送验证码的标识
  const [forbidSendSms, setForbidSendSms] = useState(false);
  // 倒计时
  const [countdown, setCountdown] = useState(CaptchaTimeout);
  // 验证码loading
  const [smsLoading, setSmsLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  const [hasUserProtocol, setHasUserProtocol] = useState(false);
  const [hasPrivacyProtocol, setHasPrivacyProtocol] = useState(false);

  const [fullNicknameVisible, setFullNicknameVisible] = useState(false);
  const [authCode, setAuthCode] = useState('');

  function afterLoginSuccess(accessToken) {
    // 记录登录状态
    localStorage.setItem('token', accessToken);
    // 跳转首页
    window.location.href = '/';
  }

  async function login(params) {
    setErrorMessage('');
    setLoading(true);
    try {
      const resp = await request('/apiService/mechanism/login/captcha/check', {
        data: params,
        method: 'POST',
      });
      if (resp.code == 200) {
        if (!resp.data.isRegist) {
          setAuthCode(resp.data.authCode);
          props.onRegist && props.onRegist(resp.data.authCode, params.account);
          // setFullNicknameVisible(true);
        } else {
          loginByAuthCode(resp.data.authCode, '');
        }
      }
      console.warn('resp', resp);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  // 继续登录
  async function loginByAuthCode(authCode, nickname) {
    setErrorMessage('');
    setLoading(true);
    try {
      const resp = await request('/apiService/mechanism/login/captcha', {
        data: {
          authCode,
          nickname,
          channelId: window.localStorage.getItem('channelId') || '',
        },
        method: 'POST',
      });
      if (resp.code == 200) {
        afterLoginSuccess(resp.data.token);
      }
      console.warn('resp', resp);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  function onSubmitClick() {
    formRef.current.validate().then((values) => {
      if (!checked) {
        Modal.confirm({
          title: '提示',
          content: (hasUserProtocol || hasPrivacyProtocol) && (
            <div style={{ display: 'flex' }}>
              <div style={{ color: '#444' }}>
                请您阅读并同意
                {hasUserProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewUserAgreementProtocol}
                  >
                    《用户协议》
                  </Link>
                )}
                {hasUserProtocol && hasPrivacyProtocol && '和'}
                {hasPrivacyProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewPrivacyPolicyProtocol}
                  >
                    《隐私政策》
                  </Link>
                )}
              </div>
            </div>
          ),
          okText: '已阅读并同意',
          onOk() {
            setChecked(true);
            login(values);
          },
        });
      } else {
        login(values);
      }
    });
  }

  async function sendSMS() {
    if (forbidSendSms) {
      return;
    }
    if (smsLoading) return;
    try {
      await formRef.current.validate(['account']);
      setSmsLoading(true);
      await request('/apiService/mechanism/login/captcha/send', {
        data: {
          account: formRef.current.getFieldValue('account'),
        },
        method: 'POST',
      });
      // 将按钮禁用
      console.warn('还是走到我le ?');
      setForbidSendSms(true);
    } catch (e) {
      console.error(e);
    }
    setSmsLoading(false);
  }

  const ViewUserAgreementProtocol = () => {
    Modal.info({
      icon: null,
      title: '用户协议',
      content: (
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            textAlign: 'left',
          }}
          dangerouslySetInnerHTML={{
            __html: props.userAgreemtnProtocol || '暂无用户协议',
          }}
        ></div>
      ),
    });
  };

  const ViewPrivacyPolicyProtocol = () => {
    Modal.info({
      icon: null,
      title: '隐私政策',
      content: (
        <div
          style={{
            maxHeight: '400px',
            overflowY: 'auto',
            textAlign: 'left',
          }}
          dangerouslySetInnerHTML={{
            __html: props.privacyPolicyProtocol || '暂无隐私政策',
          }}
        ></div>
      ),
    });
  };

  useEffect(() => {
    // 开始倒计时
    let intervalInstance = null;
    if (forbidSendSms) {
      setCountdown(CaptchaTimeout);
      let currentTimeout = CaptchaTimeout;
      intervalInstance = setInterval(() => {
        currentTimeout--;
        if (currentTimeout <= 0) {
          setForbidSendSms(false);
          intervalInstance && clearInterval(intervalInstance);
        }
        setCountdown(currentTimeout);
      }, 1e3);
    }
  }, [forbidSendSms]);

  useEffect(() => {
    if (
      props.userAgreemtnProtocol &&
      props.userAgreemtnProtocol != '<p></p>' &&
      props.userAgreemtnProtocol != '<p><br></p>'
    ) {
      setHasUserProtocol(true);
    } else {
      setHasUserProtocol(false);
    }

    if (
      props.privacyPolicyProtocol &&
      props.privacyPolicyProtocol != '<p></p>' &&
      props.privacyPolicyProtocol != '<p><br></p>'
    ) {
      setHasPrivacyProtocol(true);
    } else {
      setHasPrivacyProtocol(false);
    }
  }, [props.userAgreemtnProtocol, props.privacyPolicyProtocol]);

  useEffect(() => {
    if (!hasUserProtocol && !hasPrivacyProtocol) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [hasUserProtocol, hasPrivacyProtocol]);

  return (
    <div className={styles['login-form-wrapper']}>
      <div className={styles['login-form-error-msg']}>{errorMessage}</div>
      <Form
        className={styles['login-form']}
        layout="vertical"
        ref={formRef}
        initialValues={{ account: '', code: '' }}
      >
        <Form.Item
          field="account"
          label={
            <span
              style={{ color: '#1d4e84', fontSize: 16, fontWeight: 'bold' }}
            >
              手机号
            </span>
          }
          requiredSymbol={false}
          rules={[{ required: true, message: '请输入手机号' }]}
        >
          <Input
            prefix={<IconMobile style={{ color: '#1d4e84', fontSize: 20 }} />}
            placeholder="请输入手机号"
            onPressEnter={onSubmitClick}
            maxLength={11}
            minLength={11}
            className={styles['login-form-input']}
          />
        </Form.Item>
        <Form.Item
          field="code"
          label={
            <span
              style={{ color: '#1d4e84', fontSize: 16, fontWeight: 'bold' }}
            >
              验证码
            </span>
          }
          requiredSymbol={false}
          rules={[{ required: true, message: '请输入验证码' }]}
        >
          <Input
            className={styles['login-form-input']}
            maxLength={6}
            // loading={smsLoading}
            prefix={
              <IconCodeSquare style={{ color: '#1d4e84', fontSize: 20 }} />
            }
            // onSearch={() => {
            //   sendSMS();
            // }}
            addAfter={
              <Button
                type="text"
                loading={smsLoading}
                style={{
                  color: '#1d4e84',
                }}
                onClick={() => {
                  sendSMS();
                }}
              >
                {forbidSendSms ? `${countdown}秒后重试` : '发送验证码'}
              </Button>
            }
            // searchButton={
            //   forbidSendSms ? `${countdown}秒后重试` : <span>发送验证码</span>
            // }
            placeholder="请输入验证码"
          />
        </Form.Item>
        <Space size={16} direction="vertical">
          <Button
            type="primary"
            long
            onClick={onSubmitClick}
            loading={loading}
            style={{
              background: '#1d4e84',
            }}
          >
            登录
          </Button>
        </Space>
        <div
          style={{
            width: '100%',
            marginTop: '16px',
          }}
        >
          {/* <Space> */}
          {(hasUserProtocol || hasPrivacyProtocol) && (
            <div style={{ display: 'flex' }}>
              <div className={styles['login-form-agree-checkbox']}>
                <Checkbox
                  checked={checked}
                  onChange={setChecked}
                  style={{ marginRight: 10 }}
                />
              </div>
              <div style={{ color: '#444' }}>
                我已阅读并同意
                {hasUserProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewUserAgreementProtocol}
                  >
                    《用户协议》
                  </Link>
                )}
                {hasUserProtocol && hasPrivacyProtocol && '和'}
                {hasPrivacyProtocol && (
                  <Link
                    style={{ color: '#1d4e84' }}
                    href="javascript:;"
                    onClick={ViewPrivacyPolicyProtocol}
                  >
                    《隐私政策》
                  </Link>
                )}
                ，未注册的手机号将自动创建账号
              </div>
            </div>
          )}
          {/* </Space> */}
        </div>
      </Form>
      {/* 
      <Modal
        title={'完善信息'}
        visible={fullNicknameVisible}
        footer={null}
        style={{ width: 500 }}
        unmountOnExit
        maskClosable={false}
        focusLock={false}
        onCancel={() => {
          setFullNicknameVisible(false);
        }}
      >
        <CaptchaRegisterForm
          onClose={() => {
            setFullNicknameVisible(false);
          }}
          onSuccess={(values: any) => {
            setFullNicknameVisible(false);
            loginByAuthCode(authCode, values.nickname);
          }}
        />
      </Modal> */}
    </div>
  );
}
